<template>
    <div class="map map-indoor" id="mapIndoor" :class="{'map-alpha':alpha}">
        <div class="absolute z-10 left-2 bottom-2">
            <Btn 
                @mousedown.native.stop="setAlpha(true)" 
                @mouseup.native.stop="setAlpha(false)"
                @mouseout.native.stop="setAlpha(false)" 
                :class="'no-hover'"
                :title="$t('plans.buildingLegend')"
            >
                <i class="fa fa-building"></i>
            </Btn>
        </div>
        <div 
            id="marker-ghost"
            class="marker marker-ghost" 
            style="
                width: 50px; 
                height: 50px; 
                position: absolute; 
                z-index: 100;
                pointer-events: none;
                top: -50px; 
                left: -50px;
                display:none; 
            "
        >
            <img :src="markerWifi" style="width: 50px; height: 50px;"/>
        </div>
        <div 
            class="marker-popup" 
            style="
                position: absolute;
                z-index: 100; 
                top: -50px; 
                left: -50px;
                display:none; 
            "
        >
        </div>

    </div>
</template>

<script>

    const markerWifi = require('@/assets/img/marker-wifi.png');
    const markerBluetooth = require('@/assets/img/marker-bluetooth.png');
    const markerNFC = require('@/assets/img/marker-nfc.png');
    const markerQRCode = require('@/assets/img/marker-qrcode.png');

    import {Map} from '@/components/plans/map/MapClass';
    import {IndoorMap} from '@/components/plans/map/IndoorMapClass';
    import MapService from '@/services/map.js';
    import Btn from '@/components/ui/Button';
    import UiSwitch from '@/components/ui/Switch';
    import API from '@/services/API.js';
    import Auth from '@/services/auth.js';
    //var IndoorMap = require('@/components/plans/map/IndoorMapClass');

    export default {
        components: {
            Btn,
            UiSwitch,
        },
        computed: {
            markerWifi: function () {
                return markerWifi;
            }
        },
        data() {
            return {
                map: null,
                alpha: false
            }
        },
        methods: {
            setAlpha: function (val) {
                this.alpha = val;
            },
            setBackground: function () {

                this.map.addBackground(this.plan);
            },
            setDD: function () {
                this.map.addDragAndDrop(this.handleDrop);
                this.map.addPopup()
            },
            mapLoaded: function (e) {

                //this.map.addGeoJson(this.data);
                //this.map.addDragAndDrop();

                this.$emit('loaded');
            },
            handleDrop: function (node, position) {
                this.$emit('markerMoved', node, position);
            },
            flyTo: function (center, zoom, active) {
                if (center == null && zoom == null && active == null) {
                    this.map.activateMarker();
                    this.map._map.flyTo({center: this.center, zoom: 8.5, speed: 1});
                }
                else {
                    this.map.activateMarker(active.id);
                    this.map._map.flyTo({center: center, zoom: zoom, speed: 1});
                }

            }
        },
        mounted: function () {

            var mapConfig = {
                logoPosition: 'top-left',
                attributionControl: false,
                style: 'mapbox://styles/suivideflotte/cj3fl8ute00002rl6fy4pfv8q',
                center: [0, 0],
                zoom: 8.5,
                maxZoom: 10,
                transformRequest: (url, resourceType) => {
                    if (resourceType == 'Image' && url.startsWith(API.apiBaseURL)) {
                        return {
                            url: url,
                            headers: {
                                'Authorization': 'Bearer ' + Auth.accessToken
                            }
                        }
                    }
                }

            }

            let map = new Map('mapIndoor', mapConfig, this.mapLoaded);

            this.map = map;


        },
        name: 'indoormap',
        props: {
            center: {
                type: Array,
                default: function () {
                    return [(1.410 / 2), (-0.885 / 2)];
                },
            },
            zoom: {
                type: Number,
                default: 9,
            },
            data: {
                type: [Object],
                default: function () {
                    return {};
                }
            },
            plan: {
                type: Object,
                default: function () {
                    return {
                        data: '',
                        width: 0,
                        height: 0
                    };
                }
            }
        },
        updated: function () {

        },
        watch: {
            plan: function () {
                if (this.plan != null) {
                    this.setBackground();
                }
            },
            data: function (newValue) {
                this.map.addGeoJson(newValue);
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
